import React, { useContext } from "react";
import { AppContext } from "../../context";
import "./Associate.css";

function Associate({ storeName }) {
  const info = useContext(AppContext);

  return (
    <div className="ahp-associate-banner">
      <img
        className="ahp-image"
        src="https://aldeias-oh.s3.eu-west-3.amazonaws.com/img/ahp-logo-black.png"
        alt="aldeias históricas de Portugal logo"
        width={50}
      />
      <div className="ahp-associate-name">{storeName}</div>
      <div className="ahp-associate-sub">{info.t("isAssociate")}</div>
    </div>
  );
}

export default Associate;
